var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'main-layout ' + _vm.routeChecker},[_c('div',{staticClass:"chat"}),_vm._v(" "),_c('div',{staticClass:"main-content"},[_c('Child')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }